import { Box } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

export const ContentWrapper = styled(Box)`
  background: ${themeGet('colors.greys.porcelain')};
  border: ${themeGet('borders.2')} ${themeGet('colors.greys.alto')};
`;
